import { Component } from 'react';
import { Progress,} from "reactstrap";

export class ProgressBar extends Component {
  static displayName = ProgressBar.name;

  constructor(props) {
    super(props);
    this.state = { step: this.props.step, maxStep: this.props.maxStep, progression: 0 };
  }

  componentDidMount(){
      this.setState({progression:  Math.round((this.state.step * 100) / this.state.maxStep)});
  }

  render () {
      return (
        <div className="mt-3 mb-5">
          <div className="text-center openSans fs-12 color-blue-dark-eni">
            Étape {this.state.step} sur {this.state.maxStep}
          </div>
          <Progress 
            barClassName={'progress-bar-color'}
            value={this.state.progression} 
          />
        </div>
      );
  }
}